<template>
  <div>
    <search-accounts
      @loaded="onSearchResults"
      @cleared="showSearchResults = false"
    />
    <q-separator />
    <accounts-list
      v-if="items.length"
      :items="items"
      @selected="$emit('update:account', $event)"
    />
    <p v-if="showSearchResults && !items.length" class="q-pt-md q-px-md">
      <em>No law firms found.</em>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import AccountsList from './AccountsList.vue';
import SearchAccounts from './SearchAccounts.vue';
import { Account } from '../types';

interface Data {
  searchedAccounts: Account[],
  showSearchResults: boolean,
}

export default defineComponent({
  emits: ['update:account'],
  mixins: [HasTaskMixin],
  components: {
    AccountsList,
    SearchAccounts,
  },
  props: {
    parent: {
      type: Object as () => Account,
      required: true,
    },
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  data(): Data {
    return {
      searchedAccounts: [],
      showSearchResults: false,
    };
  },
  computed: {
    items(): Account[] {
      let accounts = this.showSearchResults ? this.searchedAccounts : [];
      if (this.account.id !== this.parent.id) {
        accounts = accounts.filter(a => a.id !== this.parent.id);
        accounts = [this.parent, ...accounts];
      }
      return accounts.filter(a => a.id !== this.account.id).slice(0, 5);
    },
  },
  methods: {
    onSearchResults(accounts: Account[]) {
      this.searchedAccounts = accounts;
      this.showSearchResults = true;
    },
  },
});
</script>
